<script setup>
import Header from '@/components/layout/Header.vue'
import MWIFooter from "@/components/mwi/Footer.vue"
import MWPFooter from "@/components/mwp/Footer.vue"
import {APP} from "@/config/app"
</script>

<template>
  <Header />

  <div class="relative flex-1 flex flex-col">
    <div class="bg-sandstone/60 min-h-[52rem] flex-1">
      <div class="transition-all duration-150">
        <main>
          <div class="relative">
            <slot />
          </div>
        </main>
      </div>
    </div>
  </div>

  <!--  Even though onboarding isn't for the private view we are keeping this check in case. -->
  <MWPFooter v-if="APP.MyWealthMode" />
  <MWIFooter v-else />
</template>
